import React from "react";
import RV from "simple-react-validator";
import * as CONFIG from "./_config";
import ls from "local-storage";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "react-bootstrap";

const axios = require("axios");

class ChangeEmail extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.validator.visibleFields = [];
    this.state = {
      ChangedEmailInfo: { newEmailAddress: "", confirmEmailAddress: "" },
    };
  }
  emailChanger = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      ChangedEmailInfo: { ...this.state.ChangedEmailInfo, [name]: value },
    });
  };

  ChangeEmailAPICall = (e) => {
    e.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return false;
    }
    let apiUrl =
      "https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/ChangeUserName";
    const data = new FormData();
    data.append("method", "POST");
    data.append("UserName", this.state.ChangedEmailInfo.newEmailAddress);
    data.append(
      "UserToken",
      ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
        ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
        : CONFIG.DATA.GUEST_TOKEN_USER
    );
    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);
    axios
      .post(apiUrl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((response) => {
        // console.log("Response", response.data);
        if (response.data.ErrorMessage.ErrorCode === 1) {
          toast.success(
            "Email address changed successfully. You will be redirected to login again."
          );
          this.props.handleClose();
          localStorage.clear();
          window.location.replace("/login");
        } else {
          toast.error(response.data.ErrorMessage.ErrorDetails);
          // this.handleClose();
        }
      })
      .catch((err) => {
        console.log("error", err.data.ErrorMessage.ErrorDetails);
        toast.error(err.data.ErrorMessage.ErrorDetails);
      });
  };

  render() {
    return (
      <Modal
        show={this.props.changeEmail}
        centered
        onHide={this.props.handleClose}
        dialogClassName="modal-50w"
      >
        <Modal.Header closeButton style={{ backgroundColor: "#f4f4f4" }}>
          <Modal.Title>Change Email Address</Modal.Title>
        </Modal.Header>
        <Form onSubmit={(e) => this.ChangeEmailAPICall(e)}>
          <Modal.Body>
            <div className="container">
              <div className="row">
                <div className="col-6">
                  <label htmlFor="newEmailAddress">
                    New Email Address
                    <span>*</span>
                  </label>
                </div>
                <div className="col-6">
                  <input
                    onChange={this.emailChanger}
                    type="email"
                    id="newEmailAddress"
                    name="newEmailAddress"
                    value={this.state.ChangedEmailInfo.newEmailAddress}
                  />
                </div>
                <span className="text-danger display-block float-left">
                  {this.validator.message(
                    "New Email Address",
                    this.state.ChangedEmailInfo.newEmailAddress,
                    "required|email"
                  )}
                </span>
                <div className="col-6">
                  <label htmlFor="confirmEmailAddress">
                    Confirm Email Address
                    <span>*</span>
                  </label>
                </div>
                <div className="col-6">
                  <input
                    onChange={this.emailChanger}
                    type="email"
                    id="confirmEmailAddress"
                    name="confirmEmailAddress"
                    value={this.state.ChangedEmailInfo.confirmEmailAddress}
                  />
                </div>
                <span className="text-danger display-block float-left">
                  {this.validator.message(
                    "Confirm Email Address",
                    this.state.ChangedEmailInfo.confirmEmailAddress,
                    `required|email|in:${this.state.ChangedEmailInfo.newEmailAddress}`
                  )}
                </span>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button rel="nofollow" type="submit">
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

export default ChangeEmail;
